import * as React from 'react';
import { ComponentProps } from 'ui';
import styles from './summary-tile-view.scss';

interface SummaryTileViewProps extends ComponentProps {
  /**
   * The displayed text when there is no data to display
   */
  textNoData?: string;
  doubleWidth?: boolean;
  hideLabelIfNoData?: boolean;
}

export const SummaryTileView: React.SFC<SummaryTileViewProps> = (props) => {
  const {
    componentId,
    className,
    label,
    children,
    textNoData,
    doubleWidth,
    hideLabelIfNoData
  } = props;

  const { container, items, item, itemsWrapper, summaryTileView } = styles;
  const hasChildren = !!React.Children.count(props.children);

  const childItems =  <div className={itemsWrapper}>
                        <div className={items}>
                        {
                          React.Children.map(children, (child, i) =>
                            <span className={`${item} ${doubleWidth ? styles.doubleWidth : ''}`}>
                              {child}
                            </span>
                          )
                        }
                        </div>
                      </div>;

  const noContentsWrapper = <p className="no-content">{textNoData}</p>;
  const contents = hasChildren ? childItems : noContentsWrapper;  
  const shouldHideLabelIfNoData = hideLabelIfNoData && !hasChildren;
  const showLabel = label && label.visible && !shouldHideLabelIfNoData;  

  return <div id={componentId} className={`col-12 ${className} ${summaryTileView}`}>
    <div className={container}>
      {showLabel && <h3>{label.text}</h3>}
        {contents}
    </div>
  </div>;
};
